module.exports = __webpack_public_path__ + "static/img/索尼 SONY Alpha 1 II.419d4c25.png";